import interPretor from "../interpretor/interPretor";

const postUserLogin = (data) =>
  interPretor.post(`/auth/signin`, JSON.stringify(data));

const postSignUp = (data) =>
  interPretor.post(`/auth/signup`, JSON.stringify(data));

const postApiSummary = (api, data) =>
  interPretor.post(`${api}`, JSON.stringify(data));

  const postStrip = (data) =>
  interPretor.post(`/user/stripe/subscribe`, JSON.stringify(data));

  const postForgotPassword = (data) =>
  interPretor.post(`/password/forgotPassword`, JSON.stringify(data));

  const postCreatePassword = (data) =>
  interPretor.post(`/password/reset_password`, JSON.stringify(data));
  
  const updateUser = (data) =>
  interPretor.put(`/user/updateuser`, JSON.stringify(data));
  
  const getUserDetails = () =>
  interPretor.get(`/user/getuser`);

  const putFreePricing = () =>
  interPretor.put(`/user/updateplan`);

  const getSeoId = (url) => interPretor.get(`/webData/seo?url=${url}`);

  const getSeoDetails = (id) => interPretor.get(`webData/response?id=${id}`);

  const getHowToFix = (id) => interPretor.get(`/webData/fixContent?title=${id}`);

  const postMetaData = (data) =>
  interPretor.post(`/webData/generate/meta`, JSON.stringify(data));

  const postImgGenerate = (data) =>
  interPretor.post(`/ai/image`, JSON.stringify(data));

export default {
  postApiSummary,
  postUserLogin,
  postSignUp,
  postStrip,
  postForgotPassword,
  postCreatePassword,
  updateUser,
  getUserDetails,
  putFreePricing,
  getSeoDetails,
  getSeoId,
  getHowToFix,
  postMetaData,
  postImgGenerate
};
